import ability from '@/libs/acl/ability'

export default function permission() {
  const getPermissions = applyDocument => {
    const perm = {
      can_send: false,
      can_update: false,
      can_update_by_inno: false,
      can_delete: false,
      can_regenerate: false,
      can_reject: true,
      can_accept: true,
      can_cancel_student: false,
      can_finish_student: false,
      can_succeed_student: false,
      can_failed_student: false,
      can_change_to_draft: false,
      can_vacation: false,
      can_return_vacation: false,
      can_old_apply_doc_update: false,
      can_old_apply_doc_delete: false,
      can_old_apply_doc_confirm: false,
    }
    const letterPermissions = applyDocument.applied_doc_permissions ? applyDocument.applied_doc_permissions : {}
    return {
      ...perm,
      ...letterPermissions,
    }
  }
  const canSend = applyDocument => getPermissions(applyDocument).can_send

  const canUpdate = applyDocument => getPermissions(applyDocument).can_update

  const canUpdateByInno = applyDocument => getPermissions(applyDocument).can_update_by_inno

  const canDelete = applyDocument => getPermissions(applyDocument).can_delete

  const canRegenerate = applyDocument => getPermissions(applyDocument).can_regenerate

  const canReject = applyDocument => getPermissions(applyDocument).can_reject

  const canAccept = applyDocument => getPermissions(applyDocument).can_accept

  const canCancelStudent = applyDocument => getPermissions(applyDocument).can_cancel_student

  const canFinishStudent = applyDocument => getPermissions(applyDocument).can_finish_student

  const canCreateSW = applyDocument => getPermissions(applyDocument).can_update

  const canAdmittedToStudy = applyDocument => getPermissions(applyDocument).can_succeed_student

  const canFailedInExam = applyDocument => getPermissions(applyDocument).can_failed_student
  const canChangeToDraft = applyDocument => getPermissions(applyDocument).can_change_to_draft

  const canVacation = applyDocument => getPermissions(applyDocument).can_vacation || getPermissions(applyDocument).can_return_vacation

  const canCreate = other => ability.can('create', 'ApplyDocument') && other
  const canCreateOld = other => ability.can('create', 'OldApplyDocument') && other
  const canUpdateOld = applyDocument => getPermissions(applyDocument).can_old_apply_doc_update
  const canDeleteOld = applyDocument => getPermissions(applyDocument).can_old_apply_doc_delete
  const canConfirmOld = applyDocument => getPermissions(applyDocument).can_old_apply_doc_confirm
  return {
    canSend,
    canUpdate,
    canDelete,
    canRegenerate,
    canReject,
    canAccept,
    canCreateSW,
    canCreate,
    canAdmittedToStudy,
    canFailedInExam,
    canCancelStudent,
    canFinishStudent,
    canChangeToDraft,
    canUpdateByInno,
    canVacation,
    canCreateOld,
    canUpdateOld,
    canDeleteOld,
    canConfirmOld,
  }
}
